module.exports = __webpack_public_path__ + "static/media/upload-file.cc56c548.svg";